import { connect } from 'react-redux'
import Flag from 'shared/components/flags/flag'
import { togglePowerGlove } from 'shared/redux/power-glove'
import * as selectors from 'shared/redux/reducers'

export default connect(
    (state) => ({
        user: selectors.getUser(state),
    }),
    { togglePowerGlove }
)(Flag)
